module.exports = __webpack_public_path__ + "img/new-employee.f34ff5f4.svg";